export const initialState = {
  loading: false,
  isSiteActivityDetailsUpdated: false,
  isSaveAndClose: false,
  errors: {}, // You can store the form errors here
  isActiveLoading: false, // You can store the active loading here
  isDeactiveLoading: false, // You can store the deactive loading here
  isResultsFound: false, // variable for result found here
  errorModal: null, // variable for error modal here
  noDataFound: false, // variable for no data found here
  alertDialog: false, // variable for alert dialog here
  alertText: '', // variable for alert text here
  apiSuccessResponse: {
    getSiteActivityDetail: false,
    updateSiteActivityDetails: false,
  }, // You can store the api success response here

  //Site Activity Details Data
  siteActivityDetailsData: [],

  siteActivityDetailsComment: '',

  //Entitlements For Sites Data
  siteEntitlementsData: [],
  siteEntitlementsTotalRecords: 0,
  isSiteEntitlementsFound: false,

  //User Details
  user: '',
  userId: 0,
};
